import React, { Component } from 'react';
import md5 from 'md5';
import { getInformationWithDataGlobalSales } from '../../services/CABE';
import { getValueCookie } from '../../services/cookieService';
import { ListOfUsers, UpdateByUsers, Users } from '../UsersManagement/Class';
import { getIndexElement } from '../../functions/searchInObject';
import { AleatoryNumber } from '../../functions/generalFunctions';
import { confirmCloseAlert } from '../../functions/alerts';
import { Menu } from '../../components/Menu/Menu';
import LoadingWindow from '../../components/LoadingWindow';
import "../../css/dashboard.css";
import { AiOutlineUser, AiOutlineSave, AiOutlineSearch } from 'react-icons/ai';
import { BsFillPersonPlusFill, BsShieldCheck, BsXCircle, BsPersonBadge } from 'react-icons/bs';

// ─── Module category grouping ────────────────────────────────────────────────
const CATEGORIES = [
    { key: 'sales',      label: 'Sales',      keywords: ['sale', 'order', 'invoice', 'customer', 'crm', 'presale', 'commission', 'pricing'] },
    { key: 'inventory',  label: 'Inventory',  keywords: ['inventor', 'product', 'item', 'stock', 'catalogue', 'bin'] },
    { key: 'warehouse',  label: 'Warehouse',  keywords: ['warehouse', 'pick', 'dispatch', 'transfer', 'logistic', 'shipping'] },
    { key: 'purchasing', label: 'Purchasing', keywords: ['purchas', 'vendor', 'po'] },
    { key: 'reports',    label: 'Reports',    keywords: ['report', 'margin', 'kpi', 'dashboard', 'analytic', 'moh', 'short', 'tracking'] },
    { key: 'admin',      label: 'Admin',      keywords: ['admin', 'user', 'setting', 'config', 'log', 'queue', 'management', 'rol'] },
];

function categorizeModule(name) {
    const lower = (name || '').toLowerCase();
    for (const cat of CATEGORIES) {
        if (cat.keywords.some(kw => lower.includes(kw))) return cat.key;
    }
    return 'other';
}

function groupModules(modules) {
    const map = {};
    for (const cat of CATEGORIES) map[cat.key] = [];
    map['other'] = [];
    for (const mod of (modules || [])) map[categorizeModule(mod.name)].push(mod);
    const result = CATEGORIES.filter(c => map[c.key].length > 0).map(c => ({ ...c, modules: map[c.key] }));
    if (map['other'].length > 0) result.push({ key: 'other', label: 'Other', modules: map['other'] });
    return result;
}

// Avatar with colored initials
const AVATAR_COLORS = ['#2563EB', '#10b981', '#8b5cf6', '#F59E0B', '#EF4444', '#06b6d4', '#f97316'];
function avatarColor(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) & 0xffffffff;
    return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}
function initials(name, surname) {
    return ((name || '?')[0]).toUpperCase() + ((surname || '')[0] || '').toUpperCase();
}

function Avatar({ name, surname, size = 36 }) {
    const bg = avatarColor((name || '') + (surname || ''));
    return (
        <div style={{
            width: size, height: size, borderRadius: '50%', background: bg, flexShrink: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: 'white', fontWeight: 800, fontSize: size * 0.36, letterSpacing: '0.01em',
        }}>
            {initials(name, surname)}
        </div>
    );
}

// ─── Component ────────────────────────────────────────────────────────────────
export default class UsersManagementV3 extends Component {
    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
        this.state = {
            allUsers: [],
            search: '',
            selectedUser: null,   // full user object with Modules
            activeTab: 'profile',
            activeCategory: '',
            showCreateModal: false,
            newUser: new UpdateByUsers('', '', '', '', '', '', '', '', '', ''),
        };
    }

    componentDidMount() {
        this.loadUsers();
    }

    async loadUsers() {
        this.ModalLoading.current.showState(true);
        const result = await getInformationWithDataGlobalSales('/user/List', null);
        this.ModalLoading.current.showState(false);
        if (result && result.data) {
            const list = new ListOfUsers();
            for (const u of result.data) list.addUser(u, getValueCookie('CompanyId'));
            this.setState({ allUsers: list.List });
        }
    }

    async selectUser(user) {
        this.ModalLoading.current.showState(true);
        const result = await getInformationWithDataGlobalSales('/user/Permissions', user);
        this.ModalLoading.current.showState(false);
        if (result && result.data) {
            user.Modules = result.data;
            const grouped = groupModules(result.data);
            this.setState({
                selectedUser: { ...user },
                activeTab: 'profile',
                activeCategory: grouped.length > 0 ? grouped[0].key : '',
            });
        }
    }

    onChangeField(field, value) {
        this.setState(prev => ({ selectedUser: { ...prev.selectedUser, [field]: value } }));
    }

    async saveProfile() {
        const { selectedUser } = this.state;
        const user = new UpdateByUsers(
            selectedUser.UserName, selectedUser.name, selectedUser.surname,
            selectedUser.phone, selectedUser.emailAddress, getValueCookie('userName')
        );
        const result = await getInformationWithDataGlobalSales('/user/update', user);
        if (result && result.data && result.data.affectedRows) {
            confirmCloseAlert('correct', 'User profile updated successfully.');
        } else {
            confirmCloseAlert('incorrect', 'Could not save changes. Please try again.');
        }
    }

    async toggleModule(moduleName) {
        const { selectedUser } = this.state;
        const modules = [...selectedUser.Modules];
        const index = getIndexElement(modules, 'name', moduleName);
        if (index === -1) return;
        const mod = modules[index];
        const newStatus = mod.Status === 1 ? 0 : 1;
        const data = {
            IdCompany: Number(getValueCookie('CompanyId')),
            UserName: selectedUser.UserName,
            IdModule: mod.IdModule,
            UpdateBy: getValueCookie('userName'),
            Status: newStatus,
        };
        const result = await getInformationWithDataGlobalSales('/user/set/Permissions', data);
        if (result && result.data && result.data.affectedRows) {
            modules[index] = { ...mod, Status: newStatus };
            this.setState(prev => ({ selectedUser: { ...prev.selectedUser, Modules: modules } }));
        } else {
            confirmCloseAlert('incorrect', 'Could not update permission. Please try again.');
        }
    }

    onChangeNewUser(field, value) {
        this.setState(prev => {
            const temporal = { ...prev.newUser, [field]: value };
            if (field === 'name' || field === 'surname') {
                const n = field === 'name' ? value : temporal.name;
                const s = field === 'surname' ? value : temporal.surname;
                temporal.userName = (n && s)
                    ? (n + '.' + s).replace(/[\s]+/g, '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
                    : '';
            }
            return { newUser: temporal };
        });
    }

    async createUser() {
        const { newUser } = this.state;
        if (!newUser.userName) {
            confirmCloseAlert('incorrect', 'Enter name and surname to generate a username.');
            return;
        }
        const payload = { ...newUser, createBy: getValueCookie('userName'), PassWord: md5('User' + AleatoryNumber(1563, 9999)) };
        const result = await getInformationWithDataGlobalSales('/user/create', payload);
        if (result && result.data && result.data.affectedRows) {
            confirmCloseAlert('correct', 'User created successfully.');
            this.setState({ showCreateModal: false, newUser: new UpdateByUsers('', '', '', '', '', '', '', '', '', '') });
            this.loadUsers();
        } else {
            confirmCloseAlert('incorrect', 'Could not create user. Please try again.');
        }
    }

    render() {
        const { allUsers, search, selectedUser, activeTab, activeCategory, showCreateModal, newUser } = this.state;

        const filteredUsers = allUsers.filter(u => {
            const q = search.toLowerCase();
            return !q || (u.name + ' ' + u.surname + ' ' + u.UserName).toLowerCase().includes(q);
        });

        const grouped = selectedUser ? groupModules(selectedUser.Modules) : [];
        const currentCat = grouped.find(c => c.key === activeCategory) || grouped[0];

        const labelStyle = { fontSize: '0.72rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: '5px' };
        const inputStyle = { borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem', width: '100%', padding: '0.45rem 0.75rem', outline: 'none', boxSizing: 'border-box' };

        return (
            <div style={{ minHeight: '100vh', background: '#F8FAFC' }}>
                <Menu />
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ marginTop: 30, background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '2rem 2rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                            <AiOutlineUser style={{ color: 'white', fontSize: '1.75rem' }} />
                        </div>
                        <div>
                            <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Users Management</h1>
                            <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                                {allUsers.length} users · Manage profiles and module permissions
                            </p>
                        </div>
                    </div>
                    <button onClick={() => this.setState({ showCreateModal: true })} style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.45rem 1.1rem', fontSize: '0.875rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                        <BsFillPersonPlusFill /> New User
                    </button>
                </div>

                {/* Master-detail layout */}
                <div style={{ display: 'flex', height: 'calc(100vh - 70px - 68px)', overflow: 'hidden' }}>

                    {/* LEFT — user list panel */}
                    <div style={{ width: '300px', flexShrink: 0, borderRight: '1px solid #E2E8F0', background: 'white', display: 'flex', flexDirection: 'column' }}>
                        {/* Search */}
                        <div style={{ padding: '0.875rem', borderBottom: '1px solid #E2E8F0' }}>
                            <div style={{ position: 'relative' }}>
                                <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8', fontSize: '1rem' }} />
                                <input
                                    type="text"
                                    placeholder="Search users..."
                                    value={search}
                                    onChange={e => this.setState({ search: e.target.value })}
                                    style={{ ...inputStyle, paddingLeft: '2rem', background: '#F8FAFC' }}
                                />
                            </div>
                        </div>

                        {/* User list */}
                        <div style={{ overflowY: 'auto', flex: 1 }}>
                            {filteredUsers.length === 0 && (
                                <div style={{ padding: '2rem', textAlign: 'center', color: '#94A3B8', fontSize: '0.875rem' }}>
                                    No users found
                                </div>
                            )}
                            {filteredUsers.map((u, i) => {
                                const isSelected = selectedUser && selectedUser.UserName === u.UserName;
                                return (
                                    <div key={i} onClick={() => this.selectUser(u)} style={{
                                        display: 'flex', alignItems: 'center', gap: '0.75rem',
                                        padding: '0.75rem 1rem', cursor: 'pointer',
                                        borderBottom: '1px solid #F1F5F9',
                                        background: isSelected ? '#EFF6FF' : 'white',
                                        borderLeft: `3px solid ${isSelected ? '#2563EB' : 'transparent'}`,
                                        transition: 'background 0.1s',
                                    }}
                                        onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = '#F8FAFC'; }}
                                        onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = 'white'; }}
                                    >
                                        <Avatar name={u.name} surname={u.surname} size={38} />
                                        <div style={{ minWidth: 0 }}>
                                            <div style={{ fontWeight: 600, fontSize: '0.875rem', color: isSelected ? '#1e40af' : '#0F172A', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {u.name} {u.surname}
                                            </div>
                                            <div style={{ fontSize: '0.72rem', color: '#94A3B8', marginTop: '1px' }}>{u.UserName}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* RIGHT — detail panel */}
                    <div style={{ flex: 1, overflowY: 'auto', padding: '1.5rem' }}>
                        {!selectedUser ? (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#94A3B8' }}>
                                <BsPersonBadge style={{ fontSize: '3.5rem', opacity: 0.3, marginBottom: '1rem' }} />
                                <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Select a user from the list</p>
                            </div>
                        ) : (
                            <>
                                {/* User header */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem', padding: '1.25rem', background: 'white', borderRadius: '12px', border: '1px solid #E2E8F0' }}>
                                    <Avatar name={selectedUser.name} surname={selectedUser.surname} size={52} />
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontWeight: 800, fontSize: '1.1rem', color: '#0F172A' }}>{selectedUser.name} {selectedUser.surname}</div>
                                        <div style={{ display: 'flex', gap: '0.5rem', marginTop: '4px', flexWrap: 'wrap' }}>
                                            <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '1px 8px', fontSize: '0.72rem', fontWeight: 700 }}>{selectedUser.UserName}</span>
                                            {selectedUser.emailAddress && <span style={{ color: '#64748B', fontSize: '0.8rem' }}>{selectedUser.emailAddress}</span>}
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <div style={{ fontSize: '1.25rem', fontWeight: 800, color: '#10b981' }}>
                                            {(selectedUser.Modules || []).filter(m => m.Status === 1).length}
                                        </div>
                                        <div style={{ fontSize: '0.72rem', color: '#64748B', fontWeight: 600 }}>modules active</div>
                                    </div>
                                </div>

                                {/* Tabs */}
                                <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.25rem' }}>
                                    {[{ key: 'profile', label: 'Profile', icon: <AiOutlineUser /> }, { key: 'permissions', label: 'Permissions', icon: <BsShieldCheck /> }].map(t => (
                                        <button key={t.key} onClick={() => this.setState({ activeTab: t.key })} style={{
                                            padding: '0.4rem 1rem', borderRadius: '8px', fontWeight: 700, fontSize: '0.8375rem', cursor: 'pointer',
                                            display: 'flex', alignItems: 'center', gap: '0.35rem', transition: 'all 0.15s',
                                            background: activeTab === t.key ? 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)' : 'white',
                                            color: activeTab === t.key ? 'white' : '#64748B',
                                            border: activeTab === t.key ? 'none' : '1.5px solid #E2E8F0',
                                            boxShadow: activeTab === t.key ? '0 2px 8px rgba(37,99,235,0.2)' : 'none',
                                        }}>
                                            {t.icon} {t.label}
                                        </button>
                                    ))}
                                </div>

                                {/* Profile tab */}
                                {activeTab === 'profile' && (
                                    <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                                        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                            <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Profile Information</span>
                                        </div>
                                        <div style={{ padding: '1.5rem' }}>
                                            <div className="row g-3">
                                                <div className="col-12 col-md-6">
                                                    <label style={labelStyle}>Name</label>
                                                    <input style={inputStyle} defaultValue={selectedUser.name} onChange={e => this.onChangeField('name', e.target.value)} />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label style={labelStyle}>Surname</label>
                                                    <input style={inputStyle} defaultValue={selectedUser.surname} onChange={e => this.onChangeField('surname', e.target.value)} />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label style={labelStyle}>Email</label>
                                                    <input style={inputStyle} type="email" defaultValue={selectedUser.emailAddress} onChange={e => this.onChangeField('emailAddress', e.target.value)} />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label style={labelStyle}>Phone</label>
                                                    <input style={inputStyle} defaultValue={selectedUser.phone} onChange={e => this.onChangeField('phone', e.target.value)} />
                                                </div>
                                                <div className="col-12 pt-1">
                                                    <button onClick={() => this.saveProfile()} style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', border: 'none', borderRadius: '8px', padding: '0.45rem 1.25rem', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                                                        <AiOutlineSave /> Save Changes
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Permissions tab */}
                                {activeTab === 'permissions' && (
                                    <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                                        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Module Permissions</span>
                                            <span style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderRadius: '999px', padding: '1px 8px', fontSize: '0.72rem', fontWeight: 700 }}>
                                                {(selectedUser.Modules || []).filter(m => m.Status === 1).length} / {(selectedUser.Modules || []).length} active
                                            </span>
                                        </div>

                                        {/* Category pills */}
                                        <div style={{ padding: '0.875rem 1.25rem', borderBottom: '1px solid #E2E8F0', display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                                            {grouped.map(cat => {
                                                const activeCount = cat.modules.filter(m => m.Status === 1).length;
                                                const isCurrent = currentCat && cat.key === currentCat.key;
                                                return (
                                                    <button key={cat.key} onClick={() => this.setState({ activeCategory: cat.key })} style={{
                                                        padding: '0.3rem 0.8rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 700, cursor: 'pointer', border: 'none',
                                                        background: isCurrent ? '#2563EB' : '#F1F5F9',
                                                        color: isCurrent ? 'white' : '#475569',
                                                        display: 'flex', alignItems: 'center', gap: '0.3rem',
                                                    }}>
                                                        {cat.label}
                                                        <span style={{ background: isCurrent ? 'rgba(255,255,255,0.25)' : '#E2E8F0', color: isCurrent ? 'white' : '#64748B', borderRadius: '999px', padding: '0 5px', fontSize: '0.68rem', fontWeight: 800 }}>
                                                            {activeCount}/{cat.modules.length}
                                                        </span>
                                                    </button>
                                                );
                                            })}
                                        </div>

                                        {/* Toggle grid */}
                                        <div style={{ padding: '1.25rem' }}>
                                            {currentCat ? (
                                                <div className="row g-2">
                                                    {currentCat.modules.map((mod, i) => {
                                                        const isOn = mod.Status === 1;
                                                        return (
                                                            <div key={i} className="col-12 col-md-6 col-xl-4">
                                                                <div onClick={() => this.toggleModule(mod.name)} style={{
                                                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                    padding: '0.65rem 0.9rem', borderRadius: '8px', cursor: 'pointer', userSelect: 'none',
                                                                    border: `1.5px solid ${isOn ? '#A7F3D0' : '#E2E8F0'}`,
                                                                    background: isOn ? 'rgba(16,185,129,0.04)' : '#FAFAFA',
                                                                }}>
                                                                    <span style={{ fontSize: '0.8125rem', fontWeight: 600, color: isOn ? '#065F46' : '#64748B', lineHeight: 1.3 }}>
                                                                        {mod.name}
                                                                    </span>
                                                                    <div style={{ width: '36px', height: '20px', borderRadius: '999px', position: 'relative', flexShrink: 0, background: isOn ? '#10b981' : '#CBD5E1', transition: 'background 0.2s' }}>
                                                                        <div style={{ position: 'absolute', top: '2px', left: isOn ? '18px' : '2px', width: '16px', height: '16px', borderRadius: '50%', background: 'white', transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <p style={{ color: '#94A3B8', textAlign: 'center', padding: '2rem 0', fontSize: '0.875rem' }}>No modules found.</p>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>

                {/* Create User Modal */}
                {showCreateModal && (
                    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ background: 'white', borderRadius: '16px', width: '540px', maxWidth: '95vw', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '1rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <div style={{ color: 'white', fontWeight: 700, fontSize: '1rem' }}>Create New User</div>
                                    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.78rem', marginTop: '2px' }}>Username is auto-generated from name + surname</div>
                                </div>
                                <button onClick={() => this.setState({ showCreateModal: false })} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', fontSize: '1.25rem', cursor: 'pointer' }}><BsXCircle /></button>
                            </div>
                            <div style={{ padding: '1.5rem' }}>
                                <div className="row g-3">
                                    <div className="col-6">
                                        <label style={labelStyle}>Name *</label>
                                        <input style={inputStyle} placeholder="First name" value={newUser.name || ''} onChange={e => this.onChangeNewUser('name', e.target.value)} />
                                    </div>
                                    <div className="col-6">
                                        <label style={labelStyle}>Surname *</label>
                                        <input style={inputStyle} placeholder="Last name" value={newUser.surname || ''} onChange={e => this.onChangeNewUser('surname', e.target.value)} />
                                    </div>
                                    <div className="col-12">
                                        <label style={labelStyle}>Username (auto-generated)</label>
                                        <input style={{ ...inputStyle, background: '#F8FAFC', color: '#64748B' }} value={newUser.userName || ''} disabled placeholder="Enter name and surname..." />
                                    </div>
                                    <div className="col-6">
                                        <label style={labelStyle}>Email</label>
                                        <input style={inputStyle} type="email" placeholder="email@company.com" value={newUser.emailAddress || ''} onChange={e => this.onChangeNewUser('emailAddress', e.target.value)} />
                                    </div>
                                    <div className="col-6">
                                        <label style={labelStyle}>Phone</label>
                                        <input style={inputStyle} value={newUser.phone || ''} onChange={e => this.onChangeNewUser('phone', e.target.value)} />
                                    </div>
                                    <div className="col-4">
                                        <label style={labelStyle}>Address</label>
                                        <input style={inputStyle} value={newUser.address || ''} onChange={e => this.onChangeNewUser('address', e.target.value)} />
                                    </div>
                                    <div className="col-4">
                                        <label style={labelStyle}>City</label>
                                        <input style={inputStyle} value={newUser.city || ''} onChange={e => this.onChangeNewUser('city', e.target.value)} />
                                    </div>
                                    <div className="col-4">
                                        <label style={labelStyle}>Country</label>
                                        <input style={inputStyle} value={newUser.country || ''} onChange={e => this.onChangeNewUser('country', e.target.value)} />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.5rem' }}>
                                    <button onClick={() => this.setState({ showCreateModal: false })} style={{ flex: 1, padding: '0.5rem', borderRadius: '8px', border: '1.5px solid #E2E8F0', background: 'white', color: '#64748B', fontWeight: 600, cursor: 'pointer' }}>Cancel</button>
                                    <button onClick={() => this.createUser()} style={{ flex: 2, padding: '0.5rem', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem' }}>
                                        <BsFillPersonPlusFill /> Create User
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
